import createVueApp from '@/common/createApp'

Styxie.Initializers.MobilePasswords = {
  edit: async(props) => {
    const { default: PasswordsEdit } = await import('@/vue_widgets/mobile/passwords/edit/index.vue')
    createVueApp(PasswordsEdit, { props, layout: null })
  }
}
